module.exports = __webpack_public_path__ + "static/img/logo8.0315bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo8.png
// module id = P4Zv
// module chunks = 0